/* eslint semi:0 */
import { path } from '../../jsCore/utils/ua'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { queryString } from '../../jsCore/utils/window'
import { info } from '../../jsCore/application/console'
import { StatsWrapper } from './components/StatsWrapper'
import { postMetadataReducer } from './postMetadataReducer'
import { postMetadataActions } from './postMetadataActions'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import { isSupportedForDomain } from '../../jsCore/application/pageDataObject'

const POST_METADATA_STATS_FEATURE_ID = 'PostMetadataStats'
const COMPONENT_NAME = 'statsContainer'
const STATE_KEY = 'postMetadataStats'
const { showReadsCounter: shouldDisplayPostStatsInEmbedLayout, debugPostStats } = queryString
const { isEmbedded } = path

function fetchPostData(props) {
  const { fetchData, fetchSpecificData } = props
  const { postId } = props.options.dataset
  if (postId) {
    fetchSpecificData(postId)
  } else {
    fetchData()
  }
}

class PostMetadataStats extends React.Component {
  componentWillMount() {
    const { IS_OVERRIDE } = this.props
    if (!IS_OVERRIDE) {
      fetchPostData(this.props)
    }
  }

  render() {
    const { stats } = this.props
    const { postId } = this.props.options.dataset
    const statsForComponent = postId ? { ...stats[postId] } : stats
    if (debugPostStats) {
      info('[QS] Rendering component with: ', stats)
    }
    return (
      <StatsWrapper>
        {statsForComponent}
      </StatsWrapper>
    )
  }
}

function definePropTypes(component) {
  const { bool, func, object } = PropTypes
  component.propTypes = {
    stats: object,
    IS_INITIALIZED: bool,
    IS_OVERRIDE: bool,
    mountAction: func,
  }
  return component
}

function mapStatsStateToProps(state) {
  const { stats, IS_OVERRIDE } = state[STATE_KEY]
  return { stats, IS_OVERRIDE }
}

export const postMetadataStatsContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStatsStateToProps, postMetadataActions)(definePropTypes(PostMetadataStats)),
  reducer: postMetadataReducer,
}

function shouldMountPostMetadataStats() {
  return (
    (isSupportedForDomain(POST_METADATA_STATS_FEATURE_ID) && !isEmbedded) ||
    shouldDisplayPostStatsInEmbedLayout
  )
}

function mountPostMetadataStats() {
  return reduxMount({
    [MOUNT_POINTS.POST_METADATA_STATS]: postMetadataStatsContainer,
  })
}

export default function initPostMetadataStats() {
  const shouldMountPostMetadata = shouldMountPostMetadataStats()
  if (shouldMountPostMetadata) {
    mountPostMetadataStats()
  }
  return shouldMountPostMetadata
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/post_metadata/postMetadataContainer.js